import React from 'react'
import {compose, lifecycle, withHandlers, withState} from 'recompose'
import _ from 'lodash'
import getUrl from "../../src/getUrl"
import Editor from './Editor'
import isAdmin from './isAdmin'

function Text(props) {
  const {text, mode, setMode, load, id, render, style, editStyle } = props
  return (
    <div
      style={{
        zIndex: 9,
        position: 'relative',
        ...(style && style),
        ...(mode === 'edit' && editStyle),
      }}
      onDoubleClick={async () => {
        if (await isAdmin()) {
          setMode('edit')
        } else {
          //window.location.href = "http://localhost:666"
        }
      }}
    >
      {mode === 'view' && (
        render
          ? render(text)
          :
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <div dangerouslySetInnerHTML={{__html: text}}/>
          </div>
      )}

      {mode === 'edit' && (
        <Editor
          text={text}
          id={id}
          changeMode={() => {
            setMode('view')
          }}
          reload={load}
        />
      )}
    </div>
  )
}

const enhance = compose(
  withState('text', 'setText', ''),
  withState('mode', 'setMode', 'view'),
  withHandlers({
    load: ({id, setText, setMode}) => () => {
      fetch(getUrl(`/api/v1/dictionaries/fw/contents/${id}`), {
        credentials: 'include',
      }).then(data => {
        return data.json()
      }).then(resp => {
        const text = _.get(resp, 'data.data[0].val')
        if (!text) {
          setMode('edit')
        } else {
          setText(text)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }),
  lifecycle({
    state: {loading: true},
    componentDidMount() {
      this.props.load()
    }
  }),
)

export default enhance(Text)


// WEBPACK FOOTER //
// ./src/text/index.js